module.exports = __webpack_public_path__ + "img/cuxiao-all.4bd0dbe5.svg";